module.exports = __webpack_public_path__ + "static/img/seohan-holdings.d029602.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/seohan-holdings.jpg
// module id = qkbn
// module chunks = 0